<script setup>
import Cookie from './Cookie.vue';

// Create cookie functions with variable value
const handleAnalytics = (value) => {

    //check if gtag is available
    if (typeof gtag === 'undefined') {
        return;
    }

    gtag('consent', 'update', {
        'ad_storage': value ? 'granted' : 'denied',
        'analytics_storage': value ? 'granted' : 'denied',
        'ad_user_data': value ? 'granted' : 'denied',
        'ad_personalization': value ? 'granted' : 'denied',
    });
};

const handleMarketing = (value) => {
    // console.log('Marketing: ', value);
};

const handlePreferences = (value) => {
    // console.log('Preferences: ', value);
};

const env = import.meta.env;
</script>

<template>
    <Cookie :analyticsFunction="handleAnalytics" :marketingFunction="handleMarketing" :preferencesFunction="handlePreferences" :preferences="false" :marketing="false" :analytics="true"/>
</template>